export default {
  plural: 'Selected materials',
  download: 'Download'
};
